import config from 'react-global-configuration';
config.set({ 
    apiUrl: 'http://inyo.in/masteradmin',
    rootUrl: 'http://inyo.in'
});

export  default config;